import { AlertCircle, RotateCw } from 'lucide-react';
import { toast } from 'sonner';
import { Alert, AlertDescription, AlertTitle } from '@aitoken/ui/components/alert';
import { Button } from '@aitoken/ui/components/button';
import { CopyId } from '@aitoken/ui/components/copy-id';
import { describeError } from '@/lib/api';
import { errorStateT, useErrorStateT } from '@/i18n/messages/errorState';

/** 错误：说清发生了什么 + 请求 ID（便于联系运营）+ 重试。 */
export function ErrorAlert({
  error,
  title,
  onRetry,
  className,
}: {
  error: unknown;
  title?: string;
  onRetry?: () => void;
  className?: string;
}) {
  const t = useErrorStateT();
  const { title: message, requestId } = describeError(error);
  return (
    <Alert variant="destructive" className={className}>
      <AlertCircle />
      <AlertTitle>{title ?? t('loadFailed')}</AlertTitle>
      <AlertDescription>
        <p>{message}</p>
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
          {requestId ? (
            <span className="inline-flex items-center gap-1.5 text-xs">
              {t('requestId')} <CopyId value={requestId} />
            </span>
          ) : null}
          {onRetry ? (
            <Button variant="outline" size="xs" onClick={onRetry}>
              <RotateCw data-icon="inline-start" />
              {t('retry')}
            </Button>
          ) : null}
        </div>
      </AlertDescription>
    </Alert>
  );
}

export function toastError(error: unknown, fallbackTitle?: string) {
  const { title, requestId } = describeError(error);
  toast.error(
    fallbackTitle ? errorStateT('toast.withTitle', { title: fallbackTitle, message: title }) : title,
    {
      description: requestId ? errorStateT('toast.requestId', { id: requestId }) : undefined,
    },
  );
}
